<button class="button {{ size }}" [ngClass]="{ 'primary': _primary, 'dialog': _dialog}"
  [attr.type]="_submit ? 'submit' : null" [disabled]="disabled" [title]="title">
  <ng-content></ng-content>
</button>